export default "__VITE_ASSET__1c7164a5__"